import { PRODUCT_IDS } from "./productContext";
import { resolvePostLoginRouteId } from "./postLoginRedirect";
import { resolveRoutePath } from "./routeGuards";
import { traceLoginLocaleFlow as emitLoginLocaleFlowTrace } from "./routeTelemetry";

/**
 * Resolve post-login dashboard target from route locale (login URL is SSOT).
 */
export function resolveLoginPostLoginTarget(userType, locale) {
  const routeId = resolvePostLoginRouteId(userType, locale);
  const ut = String(userType || "").toLowerCase();

  let product = PRODUCT_IDS.AGENT;
  if (ut === "administrators" || ut === "admin") {
    product = PRODUCT_IDS.ADMIN;
  } else if (ut === "clients" || ut === "client") {
    product = PRODUCT_IDS.AGENT;
  }

  const resolved = resolveRoutePath(routeId, {
    locale,
    product,
    useLegacyAlias: locale === "he",
  });

  return {
    routeId,
    path: resolved?.path ?? null,
  };
}

export function traceLoginLocaleFlow(payload) {
  emitLoginLocaleFlowTrace(payload);
}
